'use client';

import he from 'he';
import React from 'react';

import type { WpPost } from '@/types/wp';

import CardCarousel from '../../_components/CardCarousel/CardCarousel';
import CardCarouselChip from '../../_components/CardCarousel/CardCarouselChip';

interface Section5CarouselProps {
	data: WpPost[];
}

const Section5Carousel: React.FC<Section5CarouselProps> = ({ data }) => {
	const items = React.useMemo(
		() =>
			data.map((item) => {
				const thumbnail = item._embedded['wp:featuredmedia']?.[0]?.source_url;
				const title = item.title.rendered;
				const description = he.decode(item?.content?.rendered?.trim().replace(/<[^>]*>?/g, '') ?? '');
				const metadata = item.metadata.filter(Boolean)?.[0];

				return {
					thumbnail,
					title,
					description,
					chip: metadata ? <CardCarouselChip label={metadata} /> : null,
				};
			}),
		[data],
	);

	return <CardCarousel items={items} />;
};

export default Section5Carousel;
